// extracted by mini-css-extract-plugin
export default {"sortableHeader":"SortableHeader_sortableHeader__E8nar","sortIconActive":"SortableHeader_sortIconActive__EWGqk","sortIconInactive":"SortableHeader_sortIconInactive__94DIz"};